import { defineMessages } from 'react-intl';

export default defineMessages({
    getAQuote: {
        id: 'tdic.quote.To request a quote, please select the type of product below.  For an Employment Practices Liability quote, select Professional Liability.  For a Data Compromise quote, select Commercial Property.',
        defaultMessage: 'To request a quote, please select the type of product below.  For an Employment Practices Liability quote, select Professional Liability.  For a Data Compromise quote, select Commercial Property.'
    },
    commercialProperty: {
        id: 'tdic.quote.Commercial Property',
        defaultMessage: 'Commercial Property'
    },
    professionalLiability: {
        id: 'tdic.quote.Professional Liability',
        defaultMessage: 'Professional Liability'
    },
    workersCompensation: {
        id: 'tdic.quote.Workers\' Compensation',
        defaultMessage: 'Workers\' Compensation'
    },
    cyberLiability: {
        id: 'tdic.quote.Cyber Liability',
        defaultMessage: 'Cyber Liability'
    },
    QuoteButton: {
        id: 'tdic.quote.Request a Quote',
        defaultMessage: 'Request a Quote'
    }
});
